import { Injectable } from "@angular/core";

export enum ValueType {
	Landline,
	Mobile,
	Phone
}

@Injectable({
	providedIn: "root"
})
export class UtilityService {
	constructor() {}

	get isMobile(): boolean {
		const mq = window.matchMedia("(max-width: 768px)");
		return mq.matches;
	}

	get isFetchChannelResponsive(): boolean {
		const mq = window.matchMedia("(max-width: 900px)");
		return mq.matches;
	}

	get isMobileDevice(): boolean {
		const mq = window.matchMedia("(max-width: 800px)");
		return mq.matches;
	}

	get isHorizontalSwipe(): boolean {
		const mq = window.matchMedia("(max-width: 800px)");
		return mq.matches;
	}

	get isSmallMobileDevice(): boolean {
		const mq = window.matchMedia("(max-width: 599px)");
		return mq.matches;
	}

	get viewPortSize(): { width: number; height: number } {
		return {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight
		};
	}

	cleanMaskedValue(val: string): string {
		return val ? val.replace(/[^\x00-\x7F]/g, "").replace(/[\(\) \-]/g, "") : val;
	}

	clearFormatting(value: string, type: ValueType): string {
		if (type === ValueType.Phone || type === ValueType.Mobile || type === ValueType.Landline) {
			return value.replace(/[\(\) ]/g, "");
		}
	}

	getWithDefault<T>(objectExp: () => T, defaultValue: T): any {
		try {
			const val = objectExp();
			if (typeof val === "undefined" || val === null) {
				return defaultValue;
			}
			return val;
		} catch (e) {}
		return defaultValue;
	}

	get<T>(objectExp: () => T): T {
		return this.getWithDefault(objectExp, {} as T);
	}

	arrayGet<T>(objectExp: () => T[]): T[] {
		return this.getWithDefault(objectExp, [{} as T]);
	}

	arrayFind<T>(objectExp: () => T[], searchExp): T {
		return this.get(() => this.arrayGet(objectExp).find(searchExp));
	}

	arrayFirst<T>(objectExp: () => T[]): T {
		const arr = this.arrayGet(objectExp);
		return arr.length > 0 ? arr[0] : ({} as T);
	}

	arrayFilter<T>(objectExp: () => T[], searchExp): T[] {
		return this.arrayGet(objectExp).filter(searchExp);
	}

	arrayMap<T>(objectExp: () => T[], mapExp): T[] {
		return this.arrayGet(objectExp).map(mapExp);
	}

	get popupSize(): { height: string; width: string } {
		const mq = window.matchMedia("(max-width: 768px)");

		const viewportHeight = document.documentElement.clientHeight;

		if (mq.matches) {
			return {
				height: "auto",
				width: "100%"
			};
		}

		return {
			height: "auto",
			width: "620px"
		};
	}

	get smallPopupSize(): { height: string; width: string } {
		const mq = window.matchMedia("(max-width: 599px)");

		const viewportHeight = document.documentElement.clientHeight;

		if (mq.matches) {
			return {
				height: "auto",
				width: "100%"
			};
		}

		return {
			height: "auto",
			width: "500px"
		};
	}

	capitalizeEachWord(val: string): string {
		return val
			.toLowerCase()
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}

	capitalizeEachWordAndState(val: string): string {
		const capitalizeEachWord = this.capitalizeEachWord(val + " ");

		return capitalizeEachWord
			.replace(" Vic ", " VIC ")
			.replace(" Wa ", " WA ")
			.replace(" Nsw ", " NSW ")
			.replace(" Sa ", " SA ")
			.replace(" Tas ", " TAS ")
			.replace(" Act ", " ACT ")
			.replace(" Nt ", " NT ")
			.replace(" Qld ", " QLD ")
			.trim();
	}

	removeZerosAfterDecimal(value: string): string {
		if (value?.indexOf(".00") > 0) {
			return value.replace(".00", "");
		}
		let i;
		for (i = 0; i < 4; i++) {
			if (value?.indexOf(".") > 0) {
				if (value.slice(-1) === "0") {
					value = value.substring(0, value.length - 1);
				}
			}
		}

		return value;
	}
}
